import { defineMessages } from 'react-intl-next';

export const messages: {
	relevanceDESC: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	relevanceDESCSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	latestModifiedDateDESC: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	latestModifiedDateDESCSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	latestModifiedDateASC: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	latestModifiedDateASCSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createdDateDESC: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createdDateDESCSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createdDateASC: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createdDateASCSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sortOptionsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	relevanceDESC: {
		id: 'results-sort.relevanceDESC',
		defaultMessage: 'Relevance',
		description: 'Option in the dropdown to sort search results by relevance, order descending',
	},
	relevanceDESCSelected: {
		id: 'results-sort.relevanceDESC.selected',
		defaultMessage: 'Sort by relevance',
		description:
			'Text displayed in the dropdown indicating that search results are currently sorted by relevance, order descending',
	},
	latestModifiedDateDESC: {
		id: 'results-sort.latestModifiedDateDESC',
		defaultMessage: 'Updated (newest)',
		description:
			'Option in the dropdown to sort search results by the last updated date, order descending',
	},
	latestModifiedDateDESCSelected: {
		id: 'results-sort.latestModifiedDateDESC.selected',
		defaultMessage: 'Sort by updated (newest)',
		description:
			'Text displayed in the dropdown indicating that search results are currently sorted by the last updated date, order descending',
	},
	latestModifiedDateASC: {
		id: 'results-sort.latestModifiedDateASC',
		defaultMessage: 'Updated (oldest)',
		description:
			'Option in the dropdown to sort search results by the last updated date, order ascending',
	},
	latestModifiedDateASCSelected: {
		id: 'results-sort.latestModifiedDateASC.selected',
		defaultMessage: 'Sort by updated (oldest)',
		description:
			'Text displayed in the dropdown indicating that search results are currently sorted by the last updated date, order ascending',
	},
	createdDateDESC: {
		id: 'results-sort.createdDateDESC',
		defaultMessage: 'Created (newest)',
		description:
			'Option in the dropdown to sort search results by the last created date, order descending',
	},
	createdDateDESCSelected: {
		id: 'results-sort.createdDate.selected',
		defaultMessage: 'Sort by created (newest)',
		description:
			'Text displayed in the dropdown indicating that search results are currently sorted by the last created date, order descending',
	},
	createdDateASC: {
		id: 'results-sort.createdDateASC',
		defaultMessage: 'Created (oldest)',
		description:
			'Option in the dropdown to sort search results by the last created date, order ascending',
	},
	createdDateASCSelected: {
		id: 'results-sort.createdDateASCSelected.selected',
		defaultMessage: 'Sort by created (oldest)',
		description:
			'Text displayed in the dropdown indicating that search results are currently sorted by the last created date, order ascending',
	},
	sortOptionsLabel: {
		id: 'results-sort.sort-options.label',
		defaultMessage: 'Change list sorting',
		description: 'Text to label the sort options dropdown button',
	},
});
